import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  getProjectForms,
  removeProjectForm,
  updateProjectForm,
} from "../../../../services/projectService";
import CustomLoader from "../../../common/Loader";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import CreateNewDialog from "../CreateNewDialog";
import ProjectFormActionMenu from "./FormActionMenu";
import { logActivity } from '../../../../services/utilService';

class ProjectForms extends Component {
  state = {
    Project_ID: this.props.Project_ID,
    MPOG_Link_Form_ID: this.props.Default_Form,
    Project_Forms: [],
    loading: true,
  };

  async componentDidMount() {
    const { data: Project_Forms } = await getProjectForms(
      this.props.Project_ID
    );
    this.setState({ Project_Forms });
    this.setState({ loading: false });
  }

  handleSwitch = async (idx) => {
    let Project_Forms = [...this.state.Project_Forms];
    Project_Forms[idx].Active = !Project_Forms[idx].Active;

    const { data } = await updateProjectForm(
      Project_Forms[idx].Record_ID,
      Project_Forms[idx].Active
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_FORM_SWITCH_FAILED');
    } else {
      toaster('success', 'Updated.');
      logActivity('/projectSettings', 'PROJECT_FORM_SWITCH_SUCCESS');
      this.setState({ Project_Forms });
      
    }
  };

  handleDefault = (Form_ID) => {
    this.setState({ MPOG_Link_Form_ID: Form_ID });
    this.props.handleDefault(Form_ID);
  };

  handleNewForm = async (Form_Name) => {
    const { data } = await updateProjectForm(
      0,
      true,
      this.props.Project_ID,
      Form_Name
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_FORM_CREATE_FAILED');
    } else {
      toaster('success', 'New project form created');
      logActivity('/projectSettings', 'PROJECT_FORM_CREATE_SUCCESS');
      const { data: Project_Forms } = await getProjectForms(
        this.props.Project_ID
      );
      this.setState({ Project_Forms });
    }
  };

  handleDelete = async (Record_ID) => {
    const { data } = await removeProjectForm(Record_ID);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_FORM_DELETE_FAILED');
    } else {
      let Project_Forms = this.state.Project_Forms.filter(
        (pf) => pf.Record_ID !== Record_ID
      );
      this.setState({ Project_Forms });
      toaster('success', 'Project form removed');
      logActivity('/projectSettings', 'PROJECT_FORM_DELETE_SUCCESS');
    }
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    let { Project_Forms, MPOG_Link_Form_ID } = this.state;
    return (
      <React.Fragment>
        <CreateNewDialog handleNew={this.handleNewForm} Type="Form" />
        <table className="table table-hover table-borderless">
          <thead className="border-bottom">
            <tr>
              <th>Form Name</th>
              <th>Default</th>
              <th>Active</th>
              <th>Owner</th>
              <th>More Actions</th>
            </tr>
          </thead>
          <tbody>
            {Project_Forms.map((form, idx) => (
              <tr key={"projectForm" + form.Form_ID} className="border-bottom">
                <td>
                  <Link
                    to={{
                      pathname: "/formBuilder/",
                      Project_ID: this.props.Project_ID,
                      Form_ID: form.Form_ID,
                      Form_Name: form.Form_Name,
                      search: `?Project_ID=${this.props.Project_ID}&Form_ID=${form.Form_ID}&Form_Name=${form.Form_Name}`
                    }}
                    style={{ textDecoration: "None" }}
                  >
                    {form.Form_Name}
                  </Link>
                </td>
                <td>
                  {!form.Active ? null : form.Form_ID === MPOG_Link_Form_ID ? (
                    <div className="badge badge-primary">Default</div>
                  ) : (
                    <div
                      className="badge badge-light pointer"
                      onClick={() => this.handleDefault(form.Form_ID)}
                    >
                      Set as Default
                    </div>
                  )}
                </td>
                <td>
                  <div className="custom-control custom-switch mt-n2">
                    <input
                      id={"active" + form.Form_ID}
                      type="checkbox"
                      className="custom-control-input"
                      checked={form.Active}
                      value={form.Active}
                      onChange={() => this.handleSwitch(idx)}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor={"active" + form.Form_ID}
                    ></label>
                  </div>
                </td>
                <td>{form.Created_By}</td>
                <td>
                  <ProjectFormActionMenu
                    key={"formActions" + form.Form_ID}
                    form={form}
                    Project_ID={this.props.Project_ID}
                    handleDelete={this.handleDelete}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ProjectForms;
